// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.root{
  margin-top: 130px;
  padding-left: 20px;
  padding-right: 20px;
}


  

 
  
  .table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .table th,
  .table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
  }
  
  .table tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .table-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .table-title {
    text-align: center;
    margin-bottom: 20px;
    font-size: 24px;
    color: #333;
  }
  
  .search-input {
    width: 40%;
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
  }
  
  .styled-table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .styled-table th,
  .styled-table td {
    padding: 12px 15px;
  }
  
  .styled-table th {
    background-color: #f3f4f6;
    color: #333;
  }
  
  .clickable-row {
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .clickable-row:hover {
    background-color: #f1f1f1;
  }
  
  .expanded-content {
    padding: 10px;
    background-color: #e9e9e9;
    border-radius: 4px;
  }
  
  .pagination-controls {
    text-align: center;
  }
  
  .pagination-controls button {
    padding: 8px 12px;
    margin: 0 5px;
    border: none; 
    background-color: #ff6f61;
    color: white;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .pagination-controls button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  


  

  /* Buttons – theme green to match sidebar/header (#1f7c50) */
  .create-button {
    background-color: #1f7c50;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 5px 20px;
    font-size: 16px;
    cursor: pointer;
    height: 35px;
  }

  .create-button:hover {
    background-color: #1a6b44;
    color: white;
  }

  .submit-button4 {
    border: none;
    background-color: #1f7c50;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    outline: none;
    height: 40px;
    padding: 0 20px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .submit-button4:hover {
    outline: none;
    background-color: #1a6b44;
  }

  .submit-button,
  .submit-button2 {
    background-color: #1f7c50;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    padding: 8px 16px;
  }

  .submit-button:hover,
  .submit-button2:hover {
    background-color: #1a6b44;
    color: white;
  }

  .submit-button5 {
    background-color: transparent;
    border: 1px solid #1f7c50;
    color: #1f7c50;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease;
    outline: none;
    height: 30px !important;
  }

  .submit-button5:hover {
    outline: none;
    background-color: #1f7c50;
    color: white;
  }


  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .spinner {
    border: 4px solid rgba(31, 124, 80, 0.2);
    border-top: 4px solid #1f7c50;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  /* Download Excel Template Button - Green Outline Style */
  .submit-button-download-template {
    background-color: transparent;
    border: 2px solid #1f7c50;
    color: #1f7c50;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s ease;
    outline: none;
    font-weight: 500;
  }

  .submit-button-download-template:hover {
    background-color: #1f7c50;
    border-color: #1f7c50;
    color: #fff;
  }

  .submit-button-download-template:focus {
    outline: 2px solid #1f7c50;
    outline-offset: 2px;
  }

`, "",{"version":3,"sources":["webpack://./src/pages/SurveyQuestion/Surveys/surveys.css"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;;;;;;EAOE;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,uCAAuC;EACzC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;;;;;EAMA,4DAA4D;EAC5D;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,aAAa;IACb,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,yBAAyB;EAC3B;;EAEA;;IAEE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,iBAAiB;EACnB;;EAEA;;IAEE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,6BAA6B;IAC7B,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,uDAAuD;IACvD,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,YAAY;EACd;;;EAGA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,wCAAwC;IACxC,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;EACpC;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;;EAEA,yDAAyD;EACzD;IACE,6BAA6B;IAC7B,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB","sourcesContent":["\r\n.root{\r\n  margin-top: 130px;\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n}\r\n\r\n\r\n  \r\n\r\n \r\n  \r\n  .table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n  }\r\n  \r\n  .table th,\r\n  .table td {\r\n    border: 1px solid #ddd;\r\n    padding: 8px;\r\n    text-align: center;\r\n  }\r\n  \r\n  .table tr:nth-child(even) {\r\n    background-color: #f9f9f9;\r\n  }\r\n  \r\n  .table-container {\r\n    max-width: 800px;\r\n    margin: 0 auto;\r\n    padding: 20px;\r\n    background-color: #f9f9f9;\r\n    border-radius: 8px;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .table-title {\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n    font-size: 24px;\r\n    color: #333;\r\n  }\r\n  \r\n  .search-input {\r\n    width: 40%;\r\n    padding: 10px;\r\n    margin-bottom: 20px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .styled-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n  }\r\n  \r\n  .styled-table th,\r\n  .styled-table td {\r\n    padding: 12px 15px;\r\n  }\r\n  \r\n  .styled-table th {\r\n    background-color: #f3f4f6;\r\n    color: #333;\r\n  }\r\n  \r\n  .clickable-row {\r\n    cursor: pointer;\r\n    transition: background-color 0.3s;\r\n  }\r\n  \r\n  .clickable-row:hover {\r\n    background-color: #f1f1f1;\r\n  }\r\n  \r\n  .expanded-content {\r\n    padding: 10px;\r\n    background-color: #e9e9e9;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .pagination-controls {\r\n    text-align: center;\r\n  }\r\n  \r\n  .pagination-controls button {\r\n    padding: 8px 12px;\r\n    margin: 0 5px;\r\n    border: none; \r\n    background-color: #ff6f61;\r\n    color: white;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .pagination-controls button:disabled {\r\n    background-color: #ccc;\r\n    cursor: not-allowed;\r\n  }\r\n  \r\n\r\n\r\n  \r\n\r\n  /* Buttons – theme green to match sidebar/header (#1f7c50) */\r\n  .create-button {\r\n    background-color: #1f7c50;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    padding: 5px 20px;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n    height: 35px;\r\n  }\r\n\r\n  .create-button:hover {\r\n    background-color: #1a6b44;\r\n    color: white;\r\n  }\r\n\r\n  .submit-button4 {\r\n    border: none;\r\n    background-color: #1f7c50;\r\n    color: white;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n    outline: none;\r\n    height: 40px;\r\n    padding: 0 20px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n  }\r\n\r\n  .submit-button4:hover {\r\n    outline: none;\r\n    background-color: #1a6b44;\r\n  }\r\n\r\n  .submit-button,\r\n  .submit-button2 {\r\n    background-color: #1f7c50;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n    padding: 8px 16px;\r\n  }\r\n\r\n  .submit-button:hover,\r\n  .submit-button2:hover {\r\n    background-color: #1a6b44;\r\n    color: white;\r\n  }\r\n\r\n  .submit-button5 {\r\n    background-color: transparent;\r\n    border: 1px solid #1f7c50;\r\n    color: #1f7c50;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease, color 0.3s ease;\r\n    outline: none;\r\n    height: 30px !important;\r\n  }\r\n\r\n  .submit-button5:hover {\r\n    outline: none;\r\n    background-color: #1f7c50;\r\n    color: white;\r\n  }\r\n\r\n\r\n  .loading-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(255, 255, 255, 0.8);\r\n    z-index: 9999;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  \r\n  .spinner {\r\n    border: 4px solid rgba(31, 124, 80, 0.2);\r\n    border-top: 4px solid #1f7c50;\r\n    border-radius: 50%;\r\n    width: 40px;\r\n    height: 40px;\r\n    animation: spin 1s linear infinite;\r\n  }\r\n  \r\n  @keyframes spin {\r\n    0% { transform: rotate(0deg); }\r\n    100% { transform: rotate(360deg); }\r\n  }\r\n\r\n  /* Download Excel Template Button - Green Outline Style */\r\n  .submit-button-download-template {\r\n    background-color: transparent;\r\n    border: 2px solid #1f7c50;\r\n    color: #1f7c50;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    outline: none;\r\n    font-weight: 500;\r\n  }\r\n\r\n  .submit-button-download-template:hover {\r\n    background-color: #1f7c50;\r\n    border-color: #1f7c50;\r\n    color: #fff;\r\n  }\r\n\r\n  .submit-button-download-template:focus {\r\n    outline: 2px solid #1f7c50;\r\n    outline-offset: 2px;\r\n  }\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
